import React from 'react';

const EditIcon = (props) => {
  return (
    <svg
      width={20}
      height={19}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m14.043 8.338 1.225-1.225c.125-.125.187-.188.236-.244a2 2 0 0 0 0-2.61 4.976 4.976 0 0 0-.236-.244 4.99 4.99 0 0 0-.244-.236 2 2 0 0 0-2.61 0c-.056.049-.119.111-.244.236L10.927 5.26a8.215 8.215 0 0 0 3.116 3.079Zm-4.57-1.625-4.965 4.964c-.425.425-.637.638-.777.899s-.199.556-.316 1.145l-.39 1.95c-.067.332-.1.498-.005.593.094.094.26.06.593-.006l1.95-.39c.589-.117.883-.176 1.144-.316.261-.14.474-.352.899-.777l4.978-4.979a10.218 10.218 0 0 1-3.112-3.083Z"
        fill="#fff"
      />
    </svg>
  );
};

export default EditIcon;
